import { Box, Heading, Link } from '@chakra-ui/react'
import { Link as GatsbyLink } from 'gatsby'
import React from 'react'


const Header = ({ siteTitle }) => (
  <Box px="4" mt="20px" as="header" background="gray.800" marginBottom="1.45rem">
    <Box as="div" maxW="960px" py="2">
      <Heading fontSize="xl" margin="0" textAlign={["center","right"]}>
        <Link
          as={GatsbyLink}
          to="/"
          color="white"
          fontWeight="light"
          _hover={{ textDecor: 'none' }}
        >
          {siteTitle}
        </Link>
      </Heading>
    </Box>
   
  </Box>
)
export default Header